<template>
  <div class="popover-action-item" @click="onClick">{{title}}</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },

  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="less" scoped>
.popover-action-item {
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>